/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from 'ethers'
import type { Provider } from '@ethersproject/providers'
import type { IBep20Bytes32Contract, IBep20Bytes32ContractInterface } from '../IBep20Bytes32Contract'

const _abi = [
  {
    constant: true,
    inputs: [],
    name: 'name',
    outputs: [
      {
        name: '',
        type: 'bytes32',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'symbol',
    outputs: [
      {
        name: '',
        type: 'bytes32',
      },
    ],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
] as const

export class IBep20Bytes32Contract__factory {
  static readonly abi = _abi
  static createInterface(): IBep20Bytes32ContractInterface {
    return new utils.Interface(_abi) as IBep20Bytes32ContractInterface
  }
  static connect(address: string, signerOrProvider: Signer | Provider): IBep20Bytes32Contract {
    return new Contract(address, _abi, signerOrProvider) as IBep20Bytes32Contract
  }
}
